import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Label, Nav, NavItem, NavLink } from "reactstrap";
import SelectElement from "../../CommonElements/formelements/select";
import DatePicker from "react-datepicker";
import { Btn } from "../../AbstractElements";
import {
  getAllCheckIn,
  getMyStayFilterByActivityOptions,
} from "../../actions/axios-actions";

import { useDispatch } from "react-redux";
import { setPageStatus } from "./pagesSlice";
import moment from "moment-timezone";

const dailyCheckInFltrOptn = [
  { value: null, label: "All" },
  {
    value: { fltrOptnKey: "isInHouse", fltrOptnValue: true },
    label: `In-House`,
  },
  {
    value: { fltrOptnKey: "isReserved", fltrOptnValue: true },
    label: `Reserved`,
  },

  {
    value: { fltrOptnKey: "isEligibleForShashiCash", fltrOptnValue: true },
    label: `Eligible For Shashi Cash`,
  },
  {
    value: { fltrOptnKey: "isEligibleForShashiCash", fltrOptnValue: false },
    label: `Not Eligible For Shashi Cash`,
  },

  {
    value: { fltrOptnKey: "shashiCashEnrollment", fltrOptnValue: true },
    label: `Enrolled in Shashi Cash`,
  },
  {
    value: { fltrOptnKey: "shashiCashEnrollment", fltrOptnValue: false },
    label: `Not Enrolled in Shashi Cash`,
  },

  {
    value: { fltrOptnKey: "appSetupStatus", fltrOptnValue: 1 },
    label: `App Setup`,
  },
  {
    value: { fltrOptnKey: "appSetupStatus", fltrOptnValue: 0 },
    label: `App Not Setup`,
  },
  {
    value: { fltrOptnKey: "appSetupStatus", fltrOptnValue: -1 },
    label: `Not have Account`,
  },
];

const ActiveTabs = ({
  myActiveTab,
  myStayFilterByData,
  setMyActiveTab,
  handleSearch,
  changeSearchText,
  searchText,
  setSearchText,
  handlefieldChange,
  handleSortChange,
  handleResFilter,
  handleFromFilter,
  handleFilterByActivity,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSubmit,
  loading,
  setCheckInData,
  setLoading,
  dateFormat,
  setMyTotalRows,
  myCurrentPage,
  perPage,
  myPerPage,
  dailyCheckInFltr,
  setDailyCheckInFltr,
  myStayStartDate,
  myStayEndDate,
  setMyStayStartDate,
  setMyStayEndDate,
  updateDateRange,
  myStayFromSelectedObj,
  filterByActivity,
  setfilterByActivity,
  setMyStayFromSelectedObj,
}) => {
  const usTimeZone = "America/Los_Angeles";
  const dispatch = useDispatch();
  const [startFromDate, setStarFromtDate] = useState(null);
  const [endFromDate, setEndFromDate] = useState(null);
  const [filterByLoader, setFilterByLoader] = useState(false);

  const filterOptions = [
    // { value: "all", label: "All" },
    { value: "In-house", label: "In-house" },
    { value: "Reserved", label: "Reserved" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "Checked-out", label: "Checked-out" },
    { value: "No-Show", label: "No-Show" },
  ];

  const fromFilterOptions = [
    { value: "all", label: "All" },
    { value: "Schedule", label: "My Schedule" },
    { value: "Recommendation", label: "Recommendation" },
    { value: "Service", label: "Services" },
    { value: "Activity", label: "Activity" },
    { value: "Offer", label: "Offer" },
    { value: "Package", label: "Packages" },
    { value: "Link_Booking", label: "Link Booking" },
  ];

  const [filterByActivityOptions, setFilterByActivityOptions] = useState([
    { value: "all", label: "All" },
  ]);

  const handleGetAllCheckIn = (dailyCheckInFltr) => {
    getAllCheckIn(
      setCheckInData,
      setLoading,
      dateFormat(startDate),
      dateFormat(endDate),
      searchText,
      setMyTotalRows,
      myCurrentPage,
      myPerPage,
      dailyCheckInFltr
    );
  };

  const handleDailyCheckInFltr = (option) => {
    if (option?.value) {
      setDailyCheckInFltr(option?.value);
      handleGetAllCheckIn(option?.value);
    } else {
      setDailyCheckInFltr({});
      handleGetAllCheckIn({});
    }
  };

  const setMyStayFilterValues = () => {
    setfilterByActivity({ value: "all", label: "All" });
    setMyStayStartDate(null);
    setMyStayEndDate(null);
    getMyStayFilterByActivityOptions(
      setFilterByActivityOptions,
      setFilterByLoader,
      0,
      {
        stayFrom:
          myStayFromSelectedObj?.value !== "all"
            ? myStayFromSelectedObj?.value
            : null,
      }
    );
  };

  useEffect(() => {
    if (myActiveTab === "My-Stay") {
      setMyStayFilterValues();
    } else {
      setStarFromtDate(new Date());
      setEndFromDate(new Date());
    }
  }, [myStayFromSelectedObj?.value, myActiveTab]);

  return (
    <Fragment>
      <Col sm="12 box-col-12">
        {/* <Card> */}
        <div className="social-tab">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={myActiveTab === "Reservations" ? "active" : ""}
                onClick={() => {
                  dispatch(setPageStatus(false));
                  setMyActiveTab("Reservations");
                }}
              >
                Reservations
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={myActiveTab === "Daily CheckIn" ? "active" : ""}
                onClick={() => {
                  setSearchText("");
                  setMyActiveTab("Daily CheckIn");
                }}
              >
                Daily Check-In
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={myActiveTab === "My-Stay" ? "active" : ""}
                onClick={() => {
                  setSearchText("");
                  setMyActiveTab("My-Stay");
                }}
              >
                My Stay
              </NavLink>
            </NavItem>
          </Nav>
          {myActiveTab === "Reservations" ? (
            <div className="d-flex ">
              <div className="me-2">
                <SelectElement
                  label="Filter"
                  options={filterOptions}
                  onChange={handleResFilter}
                  defaultValue={filterOptions[0]}
                />
              </div>
            </div>
          ) : null}
          {myActiveTab === "My-Stay" ? (
            <>
              <div className="d-flex">
                <div className="me-2">
                  <SelectElement
                    label="From"
                    options={fromFilterOptions}
                    onChange={(event) => {
                      handleFromFilter(event);
                      setStarFromtDate(null);
                      setEndFromDate(null);
                    }}
                    value={myStayFromSelectedObj}
                  />
                </div>
                <div className="me-2">
                  <SelectElement
                    label="Filter by Activity"
                    options={filterByActivityOptions}
                    onChange={handleFilterByActivity}
                    value={filterByActivity || { value: "all", label: "All" }}
                    isLoading={filterByLoader}
                  />
                </div>
                <div className="me-2">
                  <Col className="d-flex flex-column">
                    <Label>{"From:"}</Label>
                    <DatePicker
                      placeholderText="Select Date"
                      className="form-control digits rounded-0"
                      selected={startFromDate}
                      onChange={(date) => {
                        const updatedDate = moment(date)
                          .tz(usTimeZone)
                          .startOf("day")
                          .toDate();
                        setStarFromtDate(updatedDate);
                        setEndFromDate(null);
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </Col>
                </div>
                <div className="me-2">
                  <Col className="d-flex flex-column">
                    <Label className="sm-bgred">{"To:"}</Label>
                    <DatePicker
                      placeholderText="Select Date"
                      className="form-control digits rounded-0"
                      selected={endFromDate}
                      minDate={startFromDate}
                      onChange={(update) => {
                        const usDate = moment(update)
                          .tz(usTimeZone)
                          .startOf("day")
                          .toDate();
                        setEndFromDate(usDate);
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </Col>
                </div>
                <div className="me-2">
                  <label class="form-label">&nbsp;</label>
                  <Btn
                    attrBtn={{
                      className: "m-r-2 m-l-2 d-block rounded-0",
                      color: "secondary",
                      disabled: loading,
                      onClick: () => {
                        updateDateRange(searchText, startFromDate, endFromDate);
                      },
                    }}
                  >
                    Get Data
                  </Btn>
                </div>
                <div className="me-2">
                  <label class="form-label">&nbsp;</label>
                  <Btn
                    attrBtn={{
                      className: "m-r-2 m-l-2 d-block rounded-0",
                      color: "secondary",
                      disabled: loading,
                      onClick: () => {
                        const resetOption = { value: "all", label: "All" };
                        setFilterByActivityOptions([resetOption]);
                        setMyStayFromSelectedObj(resetOption);
                        handleFilterByActivity(resetOption);

                        setStarFromtDate(null);
                        setEndFromDate(null);

                        setMyStayStartDate(null);
                        setMyStayEndDate(null);
                      },
                    }}
                  >
                    Clear
                  </Btn>
                </div>
              </div>
            </>
          ) : null}

          {myActiveTab === "Daily CheckIn" ? (
            <div className="d-flex ">
              <div className="social-tab p-t-0 ps-0 mb-3">
                <Row className="mt-xs-3 mt-sm-2 mt-lg-0">
                  <Col>
                    <Label>{"From:"}</Label>

                    <DatePicker
                      className="form-control digits rounded-0"
                      selected={startDate}
                      onChange={(update) => {
                        setStartDate(update);
                        setEndDate(null);
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </Col>
                  <Col>
                    <Label className="sm-bgred">{"To:"}</Label>

                    <DatePicker
                      className="form-control digits rounded-0"
                      selected={endDate}
                      minDate={startDate}
                      onChange={(update) => {
                        setEndDate(update);
                      }}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </Col>

                  <Col className="">
                    <label class="form-label">&nbsp;</label>
                    <Btn
                      attrBtn={{
                        className: "m-r-15 m-l-15 d-block rounded-0",
                        color: "secondary",
                        disabled:
                          startDate && endDate && !loading ? false : true,
                        onClick: () => {
                         handleGetAllCheckIn({includeName:true,...dailyCheckInFltr})
                        },
                      }}
                    >
                      Get Data
                    </Btn>
                  </Col>
                  <Col>
                    <SelectElement
                      label="Filter"
                      options={dailyCheckInFltrOptn}
                      onChange={handleDailyCheckInFltr}
                      defaultValue={dailyCheckInFltrOptn[0]}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}
        </div>
      </Col>
    </Fragment>
  );
};
export default ActiveTabs;
